/* Muiha Product Page — client-side logic
   Liquid data injected inline by muiha-product-page.liquid:
     window.muihaVariants — variant objects with pre-formatted prices
     window.muihaLabels   — { addToCart, soldOut }
*/
(function () {

  /* ─── QTY ─────────────────────────────────────── */
  window.muihaQty = function (delta) {
    var el = document.getElementById('muiha-qty');
    if (!el) return;
    el.value = Math.max(1, parseInt(el.value || 1) + delta);
  };

  /* ─── VARIANT SELECTOR ─────────────────────────── */
  window.muihaUpdateVariant = function (radio) {
    // Reset visual state within this option group only
    radio.parentElement.parentElement.querySelectorAll('span').forEach(function (s) {
      s.style.borderColor = 'rgba(26,22,18,0.20)';
      s.style.color       = '#1A1612';
    });
    var span = radio.nextElementSibling;
    if (span) { span.style.borderColor = '#2EB8A0'; span.style.color = '#2EB8A0'; }

    // Collect selected option values in DOM order
    var form = document.getElementById('muiha-product-form');
    if (!form) return;
    var optionNames = [];
    form.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (optionNames.indexOf(r.name) === -1) optionNames.push(r.name);
    });
    var selectedByName = {};
    form.querySelectorAll('input[type="radio"]:checked').forEach(function (r) {
      selectedByName[r.name] = r.value;
    });
    var selectedOptions = optionNames.map(function (n) { return selectedByName[n] || null; });

    // Find matching variant
    var matched  = null;
    var variants = window.muihaVariants || [];
    for (var i = 0; i < variants.length; i++) {
      var v    = variants[i];
      var opts = [v.option1, v.option2, v.option3];
      var ok   = true;
      for (var j = 0; j < selectedOptions.length; j++) {
        if (selectedOptions[j] !== null && opts[j] !== selectedOptions[j]) { ok = false; break; }
      }
      if (ok) { matched = v; break; }
    }
    if (!matched) return;

    var labels = window.muihaLabels || {};

    // Update hidden variant ID — fixes cart receiving correct SKU
    document.getElementById('muiha-variant-id').value = matched.id;

    // Price
    var priceEl = document.getElementById('muiha-price');
    if (priceEl) priceEl.textContent = matched.price;

    // Compare price + save badge
    var compareEl = document.getElementById('muiha-compare-price');
    var badgeEl   = document.getElementById('muiha-save-badge');
    var hasSaving = matched.compare_at_price && matched.compare_at_price_cents > matched.price_cents;
    if (compareEl) {
      compareEl.textContent   = hasSaving ? matched.compare_at_price : '';
      compareEl.style.display = hasSaving ? '' : 'none';
    }
    if (badgeEl) {
      if (hasSaving) {
        var pct = Math.round((matched.compare_at_price_cents - matched.price_cents) / matched.compare_at_price_cents * 100);
        badgeEl.textContent   = 'Save ' + pct + '%';
        badgeEl.style.display = '';
      } else {
        badgeEl.style.display = 'none';
      }
    }

    // ATC button
    var atcBtn = form.querySelector('button[type="submit"]');
    if (atcBtn) {
      atcBtn.textContent   = matched.available ? (labels.addToCart || 'Add to Cart') : (labels.soldOut || 'Sold Out');
      atcBtn.disabled      = !matched.available;
      atcBtn.style.opacity = matched.available ? '1' : '0.5';
      atcBtn.style.cursor  = matched.available ? 'pointer' : 'not-allowed';
    }

    // Sticky ATC sync
    var stickyPrice = document.getElementById('muiha-sticky-price');
    if (stickyPrice) stickyPrice.textContent = matched.price;
    var stickyBtn = document.getElementById('muiha-sticky-btn');
    if (stickyBtn) {
      stickyBtn.textContent = matched.available ? (labels.addToCart || 'Add to Cart') : (labels.soldOut || 'Sold Out');
      stickyBtn.disabled    = !matched.available;
    }
  };

  /* ─── ACCORDION ────────────────────────────────── */
  window.muihaToggleDesc = function (btn) {
    var panel  = btn.nextElementSibling;
    var icon   = btn.querySelector('span:last-child');
    var isOpen = panel.style.maxHeight && panel.style.maxHeight !== '0px';
    if (isOpen) {
      panel.style.maxHeight = '0px';
      icon.style.transform  = 'rotate(0deg)';
      btn.setAttribute('aria-expanded', 'false');
    } else {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      icon.style.transform  = 'rotate(45deg)';
      btn.setAttribute('aria-expanded', 'true');
    }
  };

  /* ─── STICKY ATC VISIBILITY ────────────────────── */
  function initStickyAtc() {
    var sticky  = document.getElementById('muiha-sticky-atc');
    var form    = document.getElementById('muiha-product-form');
    if (!sticky || !form) return;
    var mainBtn = form.querySelector('[type="submit"]');
    function tick() {
      if (!mainBtn) return;
      var rect    = mainBtn.getBoundingClientRect();
      var visible = rect.top < window.innerHeight && rect.bottom > 0;
      sticky.style.transform = visible ? 'translateY(100%)' : 'translateY(0)';
      sticky.setAttribute('aria-hidden', visible ? 'true' : 'false');
    }
    window.addEventListener('scroll', tick, { passive: true });
    tick();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyAtc);
  } else {
    initStickyAtc();
  }

}());
